// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioCs {
    fecha={}
    lista=[
        {
            encabezado:"1. Información personal y laboral",
            datos:[
                {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
                {valor:"", descripcion:"", tipo:1 ,label:"b. En su trabajo está expuesto a polvos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"c. Si la respuesta es afirmativa, indicar el tipo de polvos:"},
                {valor:"", descripcion:"", tipo:1 ,label:"Sílice (arena, piedra)",data:["SI","NO"], color:"background-color:#FDFD96"},
                {valor:"", descripcion:"", tipo:1 ,label:"Silicatos (cerámica, de la tierra, cemento, talco)",data:["SI","NO"], color:"background-color:#FDFD96"},
                {valor:"", descripcion:"", tipo:1 ,label:"Metálicos",data:["SI","NO"], color:"background-color:#FDFD96"},
                {valor:"", descripcion:"", tipo:1 ,label:"Asbesto",data:["SI","NO"], color:"background-color:#FDFD96"},
                {valor:"", descripcion:"", tipo:1 ,label:"Maderas",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"Harina de trigo",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"De hiervas (pasto, césped)",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"Bagazo",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"Algodón",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"Cáñamo",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"De excremento de aves",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"Polen",data:["SI","NO"], color:"background-color:#FF8000"},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Exposición en días de la semana:",data:["< Menos de 2 días","De 2 a 4 días","Todos los días","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. En su trabajo está expuesto a humos:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"f. Si la respuesta es afirmativa, indicar el tipo de humos:" },
                {valor:"", descripcion:"", tipo:1 ,label:"De soldadura",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Metálicos",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"De leña",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"De combustión de motores",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Exposición en días de la semana:",data:["< Menos de 2 días","De 2 a 4 días","Todos los días","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. En su trabajo está expuesto gases o vapores:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"i. Si la respuesta es afirmativa especifique las sustancias solas o en composición:\n"},
                {valor:"", descripcion:"", tipo:1 ,label:"j. Exposición en días de la semana:",data:["< Menos de 2 días","De 2 a 4 días","Todos los días","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"k. Uso de equipos de protección respiratoria:",data:["Nunca","A veces","Siempre"]},
                {valor:"", descripcion:"", tipo:0 ,label:"l. En caso afirmativo:" },
                {valor:"", descripcion:"", tipo:1 ,label:"Mascarillas/máscaras autorizadas por el departamento de seguridad e higiene",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Mascarillas/máscaras NO autorizadas por el departamento de seguridad e higiene",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Equipo con administración de oxígeno autorizado por el departamento de seguridad e higiene",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Equipo con administración de oxígeno NO autorizado por el departamento de seguridad e higiene",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"m. Es fumador:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"n. En caso afirmativo indicar la frecuencia (exportar de HCU):"},
                {valor:"", descripcion:"", tipo:4 ,label:"o. Valoración instrumental material particulado (aerosoles y gases):"},

            ]
        },
        {
            encabezado:"2. Antecedentes de trastornos respiratorios",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Neumoconiosis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Tuberculosis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Asma" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Bronquitis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Enfisema",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Rinitis alérgica",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Conjuntivitis alérgica",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:2 ,label:"h. Otras alergias",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"Especificar:"},
                {valor:"", descripcion:"", tipo:2 ,label:"i. Estudios y tratamientos recibidos",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:4 ,label:"Especificar:"}
            ]
        },
        {
            encabezado:"3. Antecedentes patológicos generales (HCU, poner especial atención a hipertensión arterial, diabetes, otras metabólicas y degenerativas, mentales)",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Hipertensión arterial" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Diabetes" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Otras metabólicas y degenerativas" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Mentales" ,data:["SI","NO"]}
            ]
        },
        {
            encabezado:"4. Antecedentes de familiares cercanos (padre-madre-hermanos) con patología respiratoria",
            datos:[
                {valor:"", descripcion:"", tipo:2 ,label:"a. Asma", label2:"¿Quiénes?:", valor2:"",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:2 ,label:"b. Enfisema", label2:"¿Quiénes?:", valor2:"",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:2 ,label:"c. Bronquitis", label2:"¿Quiénes?:", valor2:"",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:2 ,label:"d. Alergia", label2:"Especificar:", valor2:"",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"¿Quiénes?:"},
            ]
        },
        {
            encabezado:"5. Sintomatología actual",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Tos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Momento del día:" ,data:["Mañana","Noche","Todo el tiempo","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Frecuencia:" ,data:["Continua","Esporádica","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Factores desencadenantes o agravantes:" ,data:["Cuando trabaja","Cuando hace deporte","Cuando está en su casa","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Relación con tratamientos" ,data:["Mejora","Empeora","No se modifica","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Expectoración" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Esputo mucoso:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Purulento:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Hemoptoico:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Cantidad:" ,data:["Escasa","Abundante","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Disnea" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Tipo:" ,data:["Grandes esfuerzos","Medianos esfuerzos","Pequeños esfuerzos","Continua","Esporádica","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Dolor torácico:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Odinofagia (dolor, carraspera en la garganta):" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Rinorrea" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Estornudos frecuentes" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. ¿Qué sucede con la sintomatología respiratoria el fin de semana o en vacaciones?" ,data:["Disminuye","Desaparece","Empeora","No se modifica","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"i. ¿Otros compañeros del trabajo tienen el mismo problema respiratorio que usted?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"j. Si la respuesta es afirmativa, especifique (cuántos, puesto de trabajo, eventuales razones)" },
            ]
        },
        {
            encabezado:"6. Exploración física",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"a. Inspección:", bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"facies cianótica" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"facies rubicunda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"facies pálida" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"tórax cifosis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"tórax escoliosis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"frecuencia respiratoria (veces/minuto)" },
                {valor:"", descripcion:"", tipo:1 ,label:"tórax depresión de fosas y espacios intercostales" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"cianosis ungueal" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"dedos hipocráticos" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Conclusión " ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:0 ,label:"b. Auscultación pulmonar:" , bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"rales" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"roncus" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"sibilancias " ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Conclusión" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:0 ,label:"c. Auscultación cardíaca:" , bold:true },
                {valor:"", descripcion:"", tipo:3 ,label:"frecuencia cardíaca (veces/minuto)" },
                {valor:"", descripcion:"", tipo:1 ,label:"soplos" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"reforzamiento del segundo ruido en foco pulmonar" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Conclusión" ,data:["Normal","Anormal"]},
            ]
        },
        {
            encabezado:"7. Se realizó radiografía estándar de tórax",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Se realizó radiografía estándar de tórax" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"Si la respuesta es positiva, registre el resultado...."},
            ]
        },
        {
            encabezado:"8. Se realizó espirometría",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Se realizó espirometría" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"Si la respuesta es positiva, registre el resultado...."},
            ]
        },
        {
            encabezado:"9. Se realizó oximetría de pulso:",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Se realizó oximetría de pulso" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"Si la respuesta es positiva, registre el resultado...."},
            ]
        },
        {
            encabezado:"10. Ha recibido capacitaciones sobre ...",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"efectos en el aparato respiratorio por los polvos, humos, gases y vapores" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"procedimientos de trabajo" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"uso de herramientas y maquinaria" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"uso de los equipos de protección y otros relacionados con la salud y el trabajo" ,data:["Frecuentemente","Rara vez","Nunca"]},
            ]
        },
        {
            encabezado:"11. Conclusiones del estado de salud",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:"" },
            ]
        },
        {
            encabezado:"12. Recomendaciones en el campo de la salud (seguimiento, interconsulta, medidas de protección, capacitación) (ver documento del programa y seguir los procedimientos que se tiene para las interconsultas en la HCU).",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:"" },
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoRespiratorioCs.js